import { useAppSelector } from "@/hooks/types";
import { getUserDetails } from "@/store/user/selectors";
import { UserRole } from "@/types/user";

export const usePortalPermissions = () => {
    const user = useAppSelector(getUserDetails);

    const isUser = user?.role === "user";
    const isAdmin = user?.role === "admin";
    const isSuperAdmin = user?.role === "superAdmin";

    const canAccessPortal = isAdmin || isSuperAdmin;
    const canAccessSuperAdminFeatures = isSuperAdmin;

    return {
        isUser,
        isAdmin,
        isSuperAdmin,
        canAccessPortal,
        canAccessSuperAdminFeatures,
        userRole: user?.role as UserRole,
    };
};
